// extracted by mini-css-extract-plugin
module.exports = {"pageBanner":"_htWM1aV9","content":"_iaw68-XQ"};